const GGR_REPORT = {
  GET_GGR_REPORTS: 'adbe/v1/reports/get-reports' as 'adbe/v1/reports/get-reports',
}

export default GGR_REPORT
